import React from 'react'
import { Box } from '@mui/material'

const sha = process.env.REACT_APP_COMMIT_SHA
const deployTime = process.env.REACT_APP_DEPLOY_TIME

export const VersionBadge: React.FC = () => {
    if (!sha || !deployTime) return null
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 8,
                right: 12,
                opacity: 0.5,
                fontSize: '0.6rem',
                color: 'text.secondary',
                userSelect: 'none',
                pointerEvents: 'none',
                fontFamily: 'monospace',
                zIndex: 9999,
            }}
        >
            {sha} · {deployTime}
        </Box>
    )
}
